"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = exports.VERSION = exports.Platform = exports.SASL = exports.RTT = exports.RSM = exports.Utils = exports.Jingle = exports.Stanzas = exports.Namespaces = exports.JID = exports.JXT = exports.DataForms = exports.Constants = exports.Client = void 0;
const tslib_1 = require("tslib");
const Client_1 = (0, tslib_1.__importDefault)(require("./Client"));
exports.Client = Client_1.default;
const Constants = (0, tslib_1.__importStar)(require("./Constants"));
exports.Constants = Constants;
const RTT = (0, tslib_1.__importStar)(require("./helpers/RTT"));
exports.RTT = RTT;
const JID = (0, tslib_1.__importStar)(require("./JID"));
exports.JID = JID;
const Jingle = (0, tslib_1.__importStar)(require("./jingle"));
exports.Jingle = Jingle;
const JXT = (0, tslib_1.__importStar)(require("./jxt"));
exports.JXT = JXT;
const LibSASL = (0, tslib_1.__importStar)(require("./lib/sasl"));
exports.SASL = LibSASL;
const Namespaces = (0, tslib_1.__importStar)(require("./Namespaces"));
exports.Namespaces = Namespaces;
const Stanzas = (0, tslib_1.__importStar)(require("./protocol"));
exports.Stanzas = Stanzas;
const Utils = (0, tslib_1.__importStar)(require("./Utils"));
exports.Utils = Utils;
const Platform = (0, tslib_1.__importStar)(require("./platform"));
exports.Platform = Platform;
(0, tslib_1.__exportStar)(require("./helpers/StreamManagement"), exports);
const RSM = (0, tslib_1.__importStar)(require("./helpers/RSM"));
exports.RSM = RSM;
const DataForms = (0, tslib_1.__importStar)(require("./helpers/DataForms"));
exports.DataForms = DataForms;
exports.VERSION = Constants.VERSION;
const plugins_1 = (0, tslib_1.__importDefault)(require("./plugins"));
(0, tslib_1.__exportStar)(require("./plugins"), exports);
function createClient(opts) {
    const client = new Client_1.default(opts);
    client.use(plugins_1.default);
    return client;
}
exports.createClient = createClient;
